import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  pageRoot: {
    padding: theme.spacing(3),
  },
  pageTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  // Summary Cards
  summaryCardGrid: {
    marginBottom: theme.spacing(2),
  },
  summaryCard: {
    padding: theme.spacing(2),
    borderRadius: 8,
  },
  summaryCardLabel: {
    fontSize: 13,
    color: '#263238',
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  summaryCardValue: {
    fontSize: 24,
    fontWeight: 700,
  },
  summaryCardSub: {
    fontSize: 12,
    color: '#757575',
    marginTop: theme.spacing(0.5),
  },
  // Filter Bar
  filterBar: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    backgroundColor: '#fff',
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    alignItems: 'center',
  },
  filterItem: {
    minWidth: 160,
  },
  resetButton: {
    marginLeft: 'auto',
  },
  // Table
  tableContainer: {
    borderRadius: 8,
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    overflowX: 'auto',
  },
  tableHeader: {
    backgroundColor: '#F5F5F5',
    fontWeight: 600,
    fontSize: 13,
  },
  rowError: {
    backgroundColor: '#FEF2F2',
  },
  rowTimeout: {
    backgroundColor: '#FFFBEB',
  },
  rowArchived: {
    backgroundColor: '#F9FAFB',
  },
  rowClickable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f4ff',
    },
  },
  truncatedCell: {
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  errorCell: {
    color: '#f44336',
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  // Pagination
  paginationBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  paginationText: {
    fontSize: 13,
    color: '#555',
  },
  // Empty State
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(6, 2),
    color: '#9e9e9e',
  },
  // Detail Panel
  detailDrawer: {
    width: 600,
    maxWidth: '90vw',
    padding: theme.spacing(3),
  },
  detailHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: '2px solid #E0E0E0',
  },
  detailRow: {
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: 14,
    padding: theme.spacing(1, 0),
    borderBottom: '1px solid #F0F0F0',
  },
  detailLabel: {
    fontWeight: 600,
    minWidth: 140,
    color: '#263238',
    fontSize: 13,
  },
  detailValue: {
    flex: 1,
    wordBreak: 'break-all',
    color: '#424242',
    fontSize: 13,
  },
  payloadSection: {
    marginTop: theme.spacing(3),
  },
  payloadHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: '1px solid #E0E0E0',
  },
  payloadTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 12,
    border: '1px solid #E0E0E0',
    borderRadius: 6,
    overflow: 'hidden',
  },
  payloadTableKey: {
    padding: '6px 10px',
    fontWeight: 600,
    color: '#263238',
    backgroundColor: '#F5F5F5',
    border: '1px solid #E0E0E0',
    verticalAlign: 'top',
    width: '35%',
    fontFamily: 'monospace',
  },
  payloadTableValue: {
    padding: '6px 10px',
    color: '#424242',
    border: '1px solid #E0E0E0',
    verticalAlign: 'top',
    wordBreak: 'break-all',
    fontFamily: 'monospace',
  },
  payloadBlock: {
    backgroundColor: '#F5F5F5',
    borderRadius: 6,
    padding: theme.spacing(1.5),
    overflowX: 'auto',
    fontSize: 12,
    fontFamily: 'monospace',
    maxHeight: 300,
    overflowY: 'auto',
  },
  errorBox: {
    backgroundColor: '#FFEBEE',
    border: '1px solid #f44336',
    borderRadius: 6,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    color: '#c62828',
    fontSize: 13,
  },
  truncatedWarning: {
    backgroundColor: '#FFF8E1',
    border: '1px solid #FFB300',
    borderRadius: 6,
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontSize: 13,
    color: '#E65100',
  },
  // Status Badge
  statusBadge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
  },
}));
